{
  "0268986f0d48cdea": "Failed to load requirements. Please try again.",
  "02a45e1aac74dc6d": "Failed to update prerequisite.",
  "05fcc9f59a267872": "Postgres Requirement",
  "06e4d2977e7cd949": "Lock requirement mappings to ELIGIBILITY_ENGINE?",
  "1004a057d2b7267e": "Mapping ID",
  "10104f72c61f60fd": "Workplace Types",
  "1031170aac0e2271": "(unknown standard)",
  "1331275bc537b4c2": "Tags",
  "13ea0e4f9f8e5dff": "Failed to update Mapping Ownership.",
  "14391103278e53ff": "Linked Requirements",
  "1509f561f2416598": "Save",
  "18d67c992b71ce69": "Display Name",
  "193e54a750c539da": "Failed to update evidence definition.",
  "19766ed6ccb2f4a3": "Cancel",
  "1a83135d903dcd9e": "Evidence Definition",
  "1bb2c8090cb4ec5e": "Created {{date}}",
  "1c273344196fe0ba": "All qualifications",
  "1de9540a2246bab3": "Create Standard",
  "1ff7e2672da736d7": "Workplace IDs",
  "20ee055ad1ee378d": "Requirement Mappings",
  "21086aa64ca25c43": "Failed to load requirement mappings. Please try again.",
  "2167126e3368f142": "No prerequisites yet.",
  "24486e63f81dec5e": "Failed to delete linked requirement.",
  "2539b46db4b27709": "Edit Role Eligibility",
  "2aa9901daf6393f5": "Requirement name",
  "2edb1386b3a284e6": "Edit Standard",
  "2f69284936541865": "Mapping Ownership",
  "2f6e9daec8e9b3b3": "States",
  "30401176dda39460": "Select workplace types",
  "324b134f57c70c72": "Preview",
  "324ddac12d893a7d": "Workplaces",
  "342ec60b8c1dff58": "Create Evidence Definition",
  "35216c7957ee3dcd": "Failed to delete evidence definition.",
  "356358348d9a0262": "Start typing to search evidence definitions",
  "3843971dcfdee508": "ID",
  "395e06accb3b958a": "Edit requirement mapping",
  "3a17aa4e4abb73f6": "Stages",
  "3c0ec5157717e41f": "Leave empty to apply to all roles",
  "3c481ac202f78a62": "WorkplaceID: {{id}}",
  "3cc8ca5ee96f7abe": "Start typing to search",
  "3d44337010bfbdf7": "Created At",
  "3faaa28d5141b967": "Postgres Requirement ID:",
  "3fb1cfbfaa6ad97d": "Create Requirement Mapping",
  "415bee5a77bb8213": "Failed to delete requirement.",
  "4327226d25f9321e": "Failed to create requirement.",
  "44c2b1dce3f01022": "Comma-separated (e.g. CA, NY)",
  "44eee0ddd2f5ece7": "Edit Evidence Definition",
  "457a8abce0db81a9": "Failed to create standard.",
  "463d8035a6f8d897": "(unrecognized node)",
  "464c4ffd019e1e96": "Edit",
  "4759498ac2a719c6": "Create",
  "47d2a515ef2f05b8": "Loading...",
  "48b3f715021f7de3": "Managed by the profile-field whitelist — not editable here",
  "4916b049b37d0cb0": "All workplace types",
  "4a0576c388cfaa8d": "Evidence Definition ID",
  "4b6e9668124284db": "Start typing to search for workplaces",
  "4c9f298046750451": "24-character Mongo ObjectId",
  "4e414af41b7d4876": "Hiring",
  "501e932291eb7554": "24-character hex Mongo ObjectId",
  "531c7b28abf27600": "Unlocked",
  "53ceaa5f5473b180": "Edit Requirement",
  "57b184937623d3b1": "Failed to update requirement.",
  "5ac94805281790ee": "Format JSON",
  "5ec4492ea240afdc": "Mongo Requirement ID",
  "613f183e222fd273": "Failed to create requirement mapping.",
  "61eed57adaf7affb": "Choose a requirement the worker can self-complete before submission — a license, personal ID, or SSN — not a post-submission check.",
  "62219f0a0ed059e5": "Unknown requirement",
  "6a143555e0c4af9b": "Edit prerequisite role eligibility",
  "6e35e285106ad4a8": "Filter by name",
  "6e9a4c33b916d1a4": "No evidence definitions found",
  "7065595e20295812": "Mappings for this requirement are managed by ELIGIBILITY_ENGINE. Toggle off to unlock.",
  "72ac0d580f8c4f9f": "Copy ID",
  "72d8a700e51c8c0b": "{{count}} prerequisites",
  "73699fd80111c515": "Failed to create evidence definition.",
  "75f976a7fc65f13b": "Failed to update standard.",
  "7785223c0510e454": "Failed to update requirement mapping.",
  "78f133afd3ec55cd": "All roles",
  "79fa33618d8eaa1f": "Domain",
  "7b4339cf860e01a6": "Qualifications",
  "7d6380f3d23b1eae": "Are you sure you want to delete this prerequisite?",
  "7e402d5eb3f3668f": "Locked to ELIGIBILITY_ENGINE",
  "84453e47975d03d7": "Requires Migration",
  "865514682d0132ab": "Prerequisites",
  "88bea99c51ccc355": "Searching requirements...",
  "891dc0c8b1ae8ae1": "Search by name or paste IDs...",
  "89cf6f86f6c70fe8": "Role eligibility",
  "8a0e8b2844975daa": "Workflow Type",
  "8ffcf3be035d00fe": "No workplaces found",
  "94837b24cef292b2": "Failed to load prerequisites. Please try again.",
  "948e03e7054b919e": "Booking",
  "94f64acd4fedf861": "Leave empty to apply to all states",
  "973b69ab243b0d0a": "Failed to create linked requirement.",
  "9c63821115600f5e": "Delete prerequisite",
  "a397e25a902a7e8b": "Create Prerequisite",
  "a52ace420f2175d0": "All",
  "a7395282d1f50b89": "Failed to load linked requirements. Please try again.",
  "a7f54311a3e625f5": "Confirm Delete",
  "a92f0449a9f7235b": "Working",
  "ab6e1299d6517494": "Select qualifications",
  "ac8991ef01019cf5": "Load more",
  "aef35920b0ee1fe4": "Create Requirement",
  "af0cc56d596d8af1": "Are you sure you want to delete this requirement mapping?",
  "af581b30eecddefc": "Failed to delete requirement mapping.",
  "b073f6c68ef87211": "Scope",
  "b1c80bb5cebe85fa": "Select stages",
  "b1ca9631468707fc": "Add prerequisite to {{name}}",
  "b6fc64ca7c120613": "Delete linked requirement",
  "b764cdc0eab71374": "Unknown",
  "b9a136292f4004e2": "Standards",
  "ba3bbbe10d8bef66": "Loading…",
  "bb90ab27103e16f0": "Failed to create prerequisite.",
  "bc5078ce1707e013": "Delete requirement mapping",
  "bc77090e3672e182": "Comma-separated",
  "be049398d39842a1": "No requirements found",
  "be8a1a85b863acd4": "Filter by ID",
  "bfc08d08ea4b3844": "While this requirement is locked, all of its mappings will be read-only across the admin tool and the backend will reject any attempts to edit them.",
  "c2c2a0c9cc69eb35": "(no standard selected)",
  "c90910730b8f8383": "Property Schema",
  "c9404d3f3b44bbe2": "Edit Prerequisite",
  "c9a6fb6ee34fe03a": "Rules (ConditionTreeNode)",
  "c9f120c13bc3f754": "Standards (StandardsTreeNode)",
  "cc2111dd92b635db": "Searching workplaces...",
  "cc90340ab604bf01": "Are you sure you want to delete this linked requirement?",
  "cca10665298c5ef3": "Lock mappings to ELIGIBILITY_ENGINE",
  "ceb6cf01cd811429": "Must be a 24-character Mongo ObjectId",
  "d6aa831538edb7d5": "Create Linked Requirement",
  "d70b9e24bca26b40": "Created",
  "d74b42242108ea28": "Mappings for this requirement can be edited freely. Toggle on to lock to ELIGIBILITY_ENGINE.",
  "db171459d454694f": "This requirement has dependencies (prerequisites, links, or mappings) that must be removed first.",
  "db44b8db4f05d720": "Lock",
  "dcd1d5223f73b3a9": "Name",
  "df6c4d66b56964ae": "No linked requirements yet.",
  "dfa9dfa5cad2d8f9": "Eligibility",
  "dfee897028a99bc1": "Prerequisite deleted.",
  "e04e01b4add9f48f": "e.g. 65f2a1b3c4d5e6f7a8b9c0d1",
  "e092e70a533f66c5": "Failed to delete standard.",
  "e0cdd07f6a270b82": "Requirements",
  "e2d0a54968ead24e": "Delete",
  "e2f79e5b60330bba": "N/A",
  "e35c8e4f5cb5c554": "Updated At",
  "e87ced5e089eba2b": "ID: {{id}}",
  "ea61bc15688d1e48": "Copied!",
  "eaf5c28560a60857": "Prerequisite",
  "ed71fe3a468e163d": "Searching evidence definitions...",
  "ed82cf60e617eb63": "Search by name...",
  "f02530118b8acd1f": "Edit Requirement Mapping",
  "f0720d29ce24b75c": "Qualification Names",
  "f189411452ed2860": "All states",
  "f5f5690b0ecc41d3": "Requirement",
  "f60c824125e6408e": "Invalid JSON",
  "f631b3b20df331d5": "Lock status",
  "f8fb2c2f8b31f897": "Evidence Definitions",
  "fbab5beefa17d573": "{{count}} links",
  "fd59093451019cff": "Failed to delete prerequisite.",
  "fd5c7b4d434ccac3": "Failed to load standards. Please try again.",
  "fea31386a31f34c6": "Failed to load evidence definitions. Please try again.",
  "ff114b097c5db588": "Enter valid JSON to preview"
}
